import {
  GET_IMAGES_LOADING,
  GET_IMAGES_ACTION_DISPATCHER,
  GET_IMAGES_ACTION_REQUESTED,
  GET_IMAGES_ERROR_DISPATCHER,
} from "./Action";

const initialState = {
  successData: [],
  failureData: {},
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_IMAGES_ACTION_REQUESTED:
      return { ...state, loading: true };
    case GET_IMAGES_ACTION_DISPATCHER:
      return {
        ...state,
        successData: action.payload,
        loading: false,
      };
    case GET_IMAGES_ERROR_DISPATCHER:
      return {
        ...state,
        failureData: action.payload,
        loading: false,
      };
    case GET_IMAGES_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
